import React from "react";

import {TableCellSnapshot} from "./models";

import {parseNumber} from "@translate/T";

interface ILockedTableCellProps {
    className?: string;
    id?: string;
    style?: React.CSSProperties;

    isDragOccurring?: boolean;
    colSpan?: number;
}

class LockedTableCell extends React.PureComponent<ILockedTableCellProps> {
    private readonly cell = React.createRef<HTMLTableCellElement>();

    public getSnapshotBeforeUpdate(
        prevProps: Readonly<ILockedTableCellProps>,
    ): TableCellSnapshot | null {
        const cell = this.cell.current;
        const isDragStarting =
            this.props.isDragOccurring && !prevProps.isDragOccurring;
        if (!cell || !isDragStarting) {
            return null;
        }

        const {width, height} = cell.getBoundingClientRect();
        return {width, height};
    }

    public componentDidUpdate(
        _: ILockedTableCellProps,
        __: {},
        snapshot?: TableCellSnapshot,
    ) {
        const ref = this.cell.current;

        if (!ref) {
            return;
        }

        if (snapshot) {
            if (parseNumber(ref.style.width) === snapshot.width) {
                return;
            }
            ref.style.width = `${snapshot.width}px`;
            ref.style.height = `${snapshot.height}px`;
            return;
        }

        if (this.props.isDragOccurring || ref.style.width === null) {
            return;
        }

        // no snapshot and drag is finished - clear the inline styles
        ref.style.removeProperty("height");
        ref.style.removeProperty("width");
    }

    public render() {
        const {children, className, colSpan, id, style} = this.props;

        return (
            <td
                ref={this.cell}
                className={className}
                id={id}
                colSpan={colSpan}
                style={style}
            >
                {children}
            </td>
        );
    }
}

export default LockedTableCell;
